/* script */
//
//
//
//
//
//
//
//
//
//
//
import { getRefName } from './utils';
import SubMixin from './mixins/sub';
import BaseTable from './baseTable.js';
var __vue_script__ = {
  name: 'HeadTable',
  components: {
    BaseTable: BaseTable
  },
  mixins: [SubMixin],
  computed: {
    refName: function refName() {
      return getRefName(this.fixed, 'headTableRef');
    },
    style: function () {
      var isFixedHeader = this.isFixedHeader,
          fixed = this.fixed,
          scrollBarW = this.scrollBarW,
          scroll = this.scroll,
          useFixedHeader = this.useFixedHeader;
      var style = {};
      /**
       * jsdom 无法正确获取 scrollWidth
       * https://github.com/jsdom/jsdom/issues/1192
       */

      /* istanbul ignore if */

      if (isFixedHeader && !fixed && scrollBarW > 0) {
        style.marginBottom = "-".concat(scrollBarW, "px");
        style.paddingBottom = 0;

        if (useFixedHeader && !scroll.y) {
          style.overflowY = 'hidden';
        }
      }

      return style;
    }
  },
  mounted: function mounted() {
    var fixed = this.fixed,
        $refs = this.$refs,
        refName = this.refName;

    if (!fixed) {
      this.saveRef(refName, $refs[refName]);
    }
  },
  methods: {
    onScroll: function onScroll(e) {
      e.stopPropagation();

      if (!this.fixed) {
        this.$emit('head-scroll', e);
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: _vm.refName,
    class: _vm.prefixCls + "-header",
    style: _vm.style,
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('base-table', {
    attrs: {
      "fixed": _vm.fixed,
      "has-head": ""
    }
  })], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "headTable.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);